(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/yourbet.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/yourbet.js'); "use strict";


const {
  styleClasses
} = svs.sportsbook.sbtech_api_impl;
let isYourBetOpen = false;
let yourBetCount;
let yourBetEl;
let yourBetButtonEl;
let yourBetDescriptionEl;
let yourBetSelectionEl;
let sbtechIframe;
const elemTransitionEvent = _ref => {
  let {
    propertyName
  } = _ref;
  propertyName === 'opacity' && yourBetSelectionEl.classList.remove(styleClasses.YOURBET_SELECTION_CHANGED);
};
function render(onClickFunc, iframe) {
  if (yourBetEl) {
    return yourBetEl;
  }
  sbtechIframe = iframe || null;
  yourBetEl = document.querySelector('.js-sb-your-bet');
  yourBetButtonEl = yourBetEl.querySelector('.sb__your_bet__button');
  yourBetDescriptionEl = yourBetButtonEl.querySelector('.sb__your_bet__description');
  yourBetSelectionEl = yourBetButtonEl.querySelector('.sb__your_bet__selection');
  const yourBetButtonEvent = () => {
    if (yourBetCount > 1 && onClickFunc) {
      onClickFunc();
    }
  };
  yourBetButtonEl.addEventListener('click', yourBetButtonEvent, false);
  yourBetSelectionEl.addEventListener('transitionend', elemTransitionEvent, false);
  return function destroy() {
    yourBetButtonEl.removeEventListener('click', yourBetButtonEvent);
    yourBetSelectionEl.removeEventListener('transitionend', elemTransitionEvent);
    yourBetEl = null;
    yourBetButtonEl = null;
    yourBetDescriptionEl = null;
    yourBetSelectionEl = null;
    sbtechIframe = null;
  };
}
function toggle() {
  if (!yourBetEl || !sbtechIframe) {
    return;
  }
  yourBetEl.classList[isYourBetOpen ? 'add' : 'remove'](styleClasses.YOURBET_OPEN);
  sbtechIframe.classList[isYourBetOpen ? 'add' : 'remove']('has-your-bet');
}
function setIsYourBetOpen(isOpen) {
  isYourBetOpen = isOpen;
  toggle();
}
function updateCount(count, odds, isMinItemsReached, isMaxItemsReached) {
  if (isMaxItemsReached) {
    yourBetDescriptionEl.innerText = 'Max antal objekt valt';
  }
  if (yourBetCount == count || typeof count !== 'number') {
    return;
  }
  if (!isMinItemsReached) {
    yourBetDescriptionEl.innerText = 'Du måste välja minst 2 objekt';
  } else {
    yourBetDescriptionEl.innerText = 'Ditt Bet Builder val';
  }
  yourBetSelectionEl.classList.add(styleClasses.YOURBET_SELECTION_CHANGED);
  yourBetCount = count;
  yourBetButtonEl.classList[isMinItemsReached ? 'remove' : 'add'](styleClasses.INVALID);
  yourBetSelectionEl.innerText = count > 0 ? "".concat(count, " objekt @ ").concat(odds) : '';
}
svs.sportsbook.sbtech_api_impl.yourbet = {
  render,
  setIsYourBetOpen,
  updateCount
};
 })(window);